<template>
  <section class="">
    <!-- min-w1600 -->
    <div class="searchwrap" v-if="!$route.meta.layout || $route.meta.layout !== 'popup'">
      <div class="searchBar">
        <div class="box-ui-select searchbar-content">
          <div class="title">
            <span>{{ $t(`searchArea.partnerID`) }}</span>
          </div>
          <div>
            <input type="text" class="mr-5" v-model="reqData.memId" />
            <button class="btn-search" type="button" @click="pageSeach">
              <i class="fas fa-search"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="main-contents-wrapper" id="top">
      <template v-if="userData">
        <div class="tab-wrap">
          <button type="button" @click="onChangeType('partdetail')" class="tab-item" :class="{ active: type === 'partdetail' }">{{ $t("common.partnerDetail") }}</button>
          <!--button type="button" @click="onChangeType('gamerate')" class="tab-item" :class="{'active': type === 'gamerate'}">{{ $t('user.rollByGame') }}</button-->
          <button type="button" @click="onChangeType('rateSet')" class="tab-item" :class="{ active: type === 'rateSet' }">{{ $t("common.rateSet") }}</button>
        </div>

        <div class="allwrap" v-if="type == 'partdetail'">
          <div>
            <article class="content_wrap all">
              <div>
                <table>
                  <colgroup>
                    <col width="18%" />
                    <col width="32%" />
                    <col width="18%" />
                    <col width="32%" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th colspan="3">
                        {{ $t(`common.partner_info`) }}
                        <span class="partnerName">
                          {{ userData.memId }} (<em>{{ userData.memNick }}</em
                          >)
                        </span>
                      </th>
                      <th colspan="1" class="flexEnd">
                        <div class="saveBtnWrap">
                          <button class="btn-save user-btn-bg" @click="userInfoUpdate">{{ $t(`button.save`) }}</button>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ $t("common.id") }}</td>
                      <td>
                        <span>{{ userData.memId }}</span>
                      </td>
                      <td>{{ $t("common.nickName") }}</td>
                      <td>
                        <input type="text" v-model="userData.memNick" />
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("common.password") }}</td>
                      <!--초기화-->
                      <td>
                        <div class="pd-5">
                          <input type="text" class="mr-5" v-model="newUserPass" />
                          <button class="btn-layout btn-point mr-5" @click="userPassUpdate">{{ $t("button.edit") }}</button>
                        </div>
                        <div class="">
                          <button class="btn-layout btn-point mr10" @click="resetPassword">{{ $t("button.reset") }}</button>
                          <em>{{ $t("txt.resetPW") }} (0000)</em>
                        </div>
                      </td>
                      <td>{{ $t("common.subPassword") }}</td>
                      <td>
                        <div class="pd-5">
                          <input type="text" class="mr-5" v-model="newSubUserPass" />
                          <button class="btn-layout btn-point mr-5" @click="subUserPassUpdate">{{ $t("button.edit") }}</button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("common.cashPass") }}</td>
                      <td>
                        <input type="text" v-model="userData.cashOutPass" />
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>{{ $t("common.name") }}</td>
                      <td>
                        <input type="text" v-model="userData.memName" />
                      </td>
                      <td>{{ $t("table.head.accountNumber") }}</td>
                      <td>
                        <select v-model="userData.bank">
                          <option v-if="!userData.bank || !bankList" value="">{{ $t("common.noinfobank") }}</option>
                          <template v-for="item in bankList" :key="item.bankCode">
                            <option :value="item.bankCode">{{ item.bankNameKr }}</option>
                          </template>
                        </select>
                        <input type="text" class="ml-5" v-model="userData.bankacc" />
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("company.contact") }}</td>
                      <td>
                        <input type="text" v-model="userData.memPhone" />
                      </td>
                      <td>{{ $t("common.memLevel") }}</td>
                      <td>
                        <select v-model="userData.memLevel">
                          <option v-for="idx in levels" :key="idx.code" :value="idx.code">{{ idx.code }}</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("cash.totalBalance") }}</td>
                      <td>
                        <div class="inputBtnWrap">
                          <span>{{ numberWithCommas(userData.cashAmt) }}</span>
                          <a class="btn-inout" @click="cashModalOpen('cash')">{{ $t("searchArea.listType") }}</a>
                          <button class="btn-layout btn-point" @click="moneyMerge">{{ $t("button.changeMoney") }}</button>
                        </div>
                      </td>
                      <td>{{ $t("totalInfo.gameMoney") }}</td>
                      <td>
                        <div class="inputBtnWrap">
                          <span>{{ numberWithCommas(userData.gameMoney) }}</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("table.head.pointAmt") }}</td>
                      <td>
                        <div class="inputBtnWrap">
                          <span>{{ numberWithCommas(userData.pointAmt) }}</span>
                          <a class="btn-inout" @click="cashModalOpen('point')">{{ $t("searchArea.listType") }}</a>
                        </div>
                      </td>
                      <td>{{ $t("user.regDate") }}</td>
                      <td>
                        <span>{{ userData.regDt }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("table.head.lastLogin") }}</td>
                      <td>
                        <span>{{ userData.lastLoginDt }}</span>
                      </td>
                      <td>{{ $t("table.head.lastLogin") }} {{ $t("table.head.ip") }}</td>
                      <td>
                        <span>{{ userData.lastIp }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("searchArea.highpartner") }}</td>
                      <td>
                        <button type="button" class="btn-link" @click="detailOpen('partner', userData.recommenderId)">{{ userData.recommenderId }}</button>
                      </td>
                      <td>{{ $t("common.supPartnerList") }}</td>
                      <td>
                        <div class="supComp-list-wrap">
                          <template v-for="(item, idx) in memberFlow" :key="item.recommenderId">
                            <button v-if="userData.memId !== item.recommenderId" type="button" :class="`compColor${idx} btn-link`" @click="detailOpen('partner', item.recommenderId)">
                              <span :class="item.partnerLevel">{{ item.partnerLevelName }}</span
                              >{{ item.recommenderId }}({{ item.recommenderNick }})
                            </button>
                            <span v-if="item.siteId !== item.recommenderId && userData.memId === item.recommenderId" class="compColor-target">
                              {{ item.recommenderId }}
                            </span>
                          </template>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <!--div class="button-wrap">
                    <button class="user-btn-bg" type="button" @click="_memLogout(userData.memId)">{{ $t('table.head.block') }}</button>
                    <button class="user-btn-bg" type="button" @click="cashModalOpen('point_in')">{{ $t('common.givepoint') }}</button>
                    <button class="user-btn-bg" type="button" @click="cashModalOpen('point_out')">{{ $t('common.repoint') }}</button>
                    <button class="user-btn-bg" type="button" @click="cashModalOpen('cash_in')">{{ $t('common.payReserve') }}</button>
                    <button class="user-btn-bg" type="button" @click="cashModalOpen('cash_out')">{{ $t('common.reReserve') }}</button>
                  </div-->

                <div class="button-wrap">
                  <button class="user-btn-bg" type="button" data-link="betList" @click="parentLinkMove('/bet/list/allNew', userData.memId)">{{ $t("betting.totalBetCount") }}</button>
                  <button class="user-btn-bg" type="button" data-link="deposit" @click="parentLinkMove('/user/cash/in/report', userData.memId)">{{ $t("common.depH") }}</button>
                  <button class="user-btn-bg" type="button" data-link="withdraw" @click="parentLinkMove('/user/cash/out/report', userData.memId)">{{ $t("common.WithH") }}</button>
                  <button class="user-btn-bg" type="button" data-link="point" @click="parentLinkMove('/user/pointList', userData.memId)">{{ $t("common.pointH") }}</button>
                  <button class="user-btn-bg" type="button" data-link="" @click="parentLinkMovePopup('/user/cash/cashMoveHistory', userData.memId)">{{ $t("common.cashH") }}</button>
                  <button class="user-btn-bg" type="button" data-link="connect" @click="parentLinkMove('/user/userTracking', userData.memId)">{{ $t("common.accLog") }}</button>
                  <button class="user-btn-bg" type="button" @click="msgOpen = true">{{ $t("common.sendMsg") }}</button>
                  <button class="user-btn-bg" type="button" @click="parentLinkMove('/board/message', userData.memId)">{{ $t("common.MsgH") }}</button>
                </div>

                <div class="part-wrap">
                  <div class="part-box">
                    <table>
                      <colgroup>
                        <col width="37%" />
                        <col width="63%" />
                      </colgroup>
                      <thead>
                        <tr>
                          <th>{{ $t("user.funcSet") }}</th>
                          <th class="flexEnd">
                            <div class="saveBtnWrap">
                              <button class="btn-save user-btn-bg" @click="userSettingUpdate">{{ $t("button.save") }}</button>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{{ $t("user.isLogin") }}</td>
                          <td>
                            <input type="checkbox" class="set-switch" @click="switchToggle" v-model="userData.loginYn" />
                          </td>
                        </tr>
                        <tr>
                          <td>{{ $t("common.actLock") }}</td>
                          <td>
                            <div style="display: flex; align-items: center; justify-content: space-between">
                              <input type="checkbox" class="set-switch" @click="switchToggle" v-model="userData.memLockYn" />
                              <button class="btn-layout user-btn-bl" @click="lockBotMemberSetting">{{ $t("button.allsavesub") }}</button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>{{ $t("common.setBlack") }}</td>
                          <td>
                            <div style="display: flex; align-items: center; justify-content: space-between">
                              <input type="checkbox" class="set-switch" @click="switchToggle" v-model="userData.memBlackYn" />
                              <button class="btn-layout user-btn-bl" @click="blackBotMemberSetting">{{ $t("button.allsavesub") }}</button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>{{ $t("common.actReqYN") }}</td>
                          <td>
                            <input type="checkbox" class="set-switch" @click="switchToggle" v-model="userData.accInfoRequestYn" />
                          </td>
                        </tr>
                        <tr>
                          <td>{{ $t("common.lowmoneytrans") }} ({{ $t("common.remi") }})</td>
                          <td>
                            <input type="checkbox" class="set-switch" @click="switchToggle" v-model="userData.cashSendYn" />
                          </td>
                        </tr>
                        <tr>
                          <td>{{ $t("common.lowmoneytrans") }} ({{ $t("common.coll") }})</td>
                          <td>
                            <input type="checkbox" class="set-switch" @click="switchToggle" v-model="userData.cashReceiveYn" />
                          </td>
                        </tr>
                        <tr>
                          <td>{{ $t("common.recommendYnOn") }}</td>
                          <td>
                            <input type="checkbox" class="set-switch" @click="switchToggle" v-model="userData.recommendYn" />
                          </td>
                        </tr>
                        <tr>
                          <td>{{ $t("common.bottomSet") }}</td>
                          <td>
                            <input type="checkbox" class="set-switch" @click="switchToggle" v-model="userData.subMemRateModifyYn" />
                          </td>
                        </tr>
                        <tr>
                          <td>{{ $t("table.head.block") }}</td>
                          <td>
                            <button class="btn-inout" type="button" @click="_memLogout(userData.memId)">{{ $t("table.head.block") }}</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="part-box">
                    <div class="part-in">
                      <table>
                        <colgroup>
                          <col width="35%" />
                          <col width="65%" />
                        </colgroup>
                        <thead>
                          <tr>
                            <th>{{ $t("common.idlingSet") }}</th>
                            <!--공회전 기능 설정-->
                            <th class="flexEnd">
                              <div class="saveBtnWrap">
                                <button class="btn-layout user-btn-bl" @click="blankBotMemberSetting">{{ $t("button.allsavesub") }}</button>
                                <button class="btn-save user-btn-bg" @click="userSettingUpdateBlank">{{ $t("button.save") }}</button>
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{{ $t("common.idling") }}({{ $t("table.head.casino") }})</td>
                            <td>
                              <div class="inputBtnWrap">
                                <input type="checkbox" class="set-switch" @click="switchToggle" v-model="isBlankSpinCasinoRate" />
                                <input type="text" name="" v-model="userData.blankSpinCasinoRate" onkeypress="return /^-?[0-9]*$/.test(this.value+event.key)" />%
                                <div class="hoverWrap">
                                  <span class="icon_q" @mouseover="qhover = true" @mouseleave="qhover = false">?</span>
                                  <p v-if="qhover">
                                    "카지노" 공베팅은 다음과 같은 공식이 적용됩니다.<br />
                                    당첨금이 베팅금 보다 큰 경우는 확률계산에서 제외되어 공베팅이 적용되지 않습니다.<br />
                                    이점 숙지하시고 이용해 주시기 바랍니다.<br />
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>{{ $t("common.idling") }}({{ $t("table.head.slot") }})</td>
                            <td>
                              <div class="inputBtnWrap">
                                <input type="checkbox" class="set-switch" @click="switchToggle" v-model="isBlankSpinSlotRate" />
                                <input type="text" name="" v-model="userData.blankSpinSlotRate" onkeypress="return /^-?[0-9]*$/.test(this.value+event.key)" />%
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="part-in">
                      <table>
                        <colgroup>
                          <col width="35%" />
                          <col width="65%" />
                        </colgroup>
                        <thead>
                          <tr>
                            <th colspan="2">{{ $t("common.manageBonus") }}</th>
                            <!--th class="flexEnd">
                                   <div class="saveBtnWrap">
                                     <button class="btn-layout user-btn-bl">{{ $t('button.allsavesub') }}</button>
                                     <button class="btn-save user-btn-bg" @click="setUserBonus">{{ $t('button.save') }}</button>
                                   </div>
                                 </th-->
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{{ $t("common.firstChargeSU") }}</td>
                            <td>
                              <div class="inputBtnWrap">
                                <input type="number" v-model="userBonus.fstChrgByJoinRate" /> <span>%</span> <button class="btn-save btn-red btn-layout" @click="setUserBonus('fstChrgByJoinRate')">{{ $t("button.save") }}</button>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>{{ $t("common.firstChargeDay") }}</td>
                            <td>
                              <div class="inputBtnWrap">
                                <input type="number" v-model="userBonus.fstChrgByDailyRate" /> <span>%</span> <button class="btn-save btn-red btn-layout" @click="setUserBonus('fstChrgByDailyRate')">{{ $t("button.save") }}</button>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>{{ $t("common.ateveryCharge") }}</td>
                            <td>
                              <div class="inputBtnWrap">
                                <input type="number" v-model="userBonus.fstChrgByEveryTimeRate" /> <span>%</span> <button class="btn-save btn-red btn-layout" @click="setUserBonus('fstChrgByEveryTimeRate')">{{ $t("button.save") }}</button>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>{{ $t("common.maxpay") }}</td>
                            <td>
                              <div class="inputBtnWrap">
                                <input type="number" :value="formatValueWithCommas(userBonus.bonusLimit)" @input="userBonus.bonusLimit = $event.target.value.replace(/,/g, '')" />
                                <span>{{ $t("common.won") }}</span>
                                <button class="btn-save btn-red btn-layout" @click="setUserBonus('bonusLimit')">{{ $t("button.save") }}</button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <table>
                  <colgroup>
                    <col width="35%" />
                    <col width="65%" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th colspan="2">{{ $t("common.partner_ses") }}</th>
                      <!--파트너활동-->
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ $t("table.head.totalCashInAmt") }}</td>
                      <td>{{ userData.totalCashInAmt }}</td>
                    </tr>
                    <tr>
                      <td>{{ $t("table.head.totalCashOutAmt") }}</td>
                      <td>{{ userData.totalCashOutAmt }}</td>
                    </tr>
                    <tr>
                      <td>{{ $t("common.days3points") }}</td>
                      <td>{{ userData.totalChangePointAmt }}</td>
                    </tr>
                    <!--tr>
                       <td>{{ $t('common.days3points') }}</td>
                       <td>{{ userData.totalLoginCount }}</td>
                     </tr-->
                  </tbody>
                </table>

                <table>
                  <thead>
                    <tr>
                      <th>{{ $t("common.partnerMemo") }}</th>
                      <th class="flexEnd">
                        <div class="saveBtnWrap">
                          <button class="btn-save user-btn-bg" @click="userMemoUpdate">{{ $t("button.save") }}</button>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colspan="2">
                        <textarea class="fc-eee" id="accessDesc" name="accessDesc" v-model="userData.memo"></textarea>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div style="max-height: 290px; overflow: auto; min-height: 150px">
                  <table class="mamListTable">
                    <colgroup>
                      <col width="15.5%" />
                      <col width="15.5%" />
                      <col width="23%" />
                      <col width="23%" />
                      <!-- <col width="23%"> -->
                    </colgroup>
                    <thead>
                      <tr>
                        <th colspan="4">{{ $t("common.memList") }}</th>
                      </tr>
                    </thead>
                    <tbody class="memTable">
                      <tr>
                        <td>{{ $t("common.id") }}</td>
                        <td>{{ $t("common.nickName") }}</td>
                        <td>{{ $t("common.totalBalance") }}</td>
                        <td>{{ $t("table.head.pointAmt") }}</td>
                        <!-- <td>{{ $t('table.head.gameMoney') }}</td> -->
                      </tr>
                      <template v-if="subUserList.length !== 0">
                        <tr v-for="item in subUserList" :key="item.memId">
                          <td>
                            <button type="button" class="btn-link fc-green" @click="detailOpen('user', item.memId)">{{ item.memId }}</button>
                          </td>
                          <td>
                            <button type="button" class="btn-link" @click="detailOpen('user', item.memNick)">{{ item.memNick }}</button>
                          </td>
                          <td>{{ numberWithCommas(item.cashAmt) }}</td>
                          <td>{{ numberWithCommas(item.pointAmt) }}</td>
                          <!-- <td>{{ numberWithCommas(item.gameMoney) }}</td> -->
                        </tr>
                      </template>
                      <template v-else>
                        <tr>
                          <td colspan="6">{{ $t("txt.noData") }}</td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </article>
          </div>
        </div>

        <div class="allwrap" v-if="type == 'gamerate'">
          <ul class="setTab">
            <li :class="{ active: setRate === 'casino' }" @click="changeTabRate('casino')">{{ $t("common.rateSettingByGame") }}({{ $t("table.head.casino") }})</li>
            <li :class="{ active: setRate === 'slot' }" @click="changeTabRate('slot')">{{ $t("common.rateSettingByGame") }}({{ $t("table.head.slot") }})</li>
            <li :class="{ active: setRate === 'minigame' }" @click="changeTabRate('minigame')">{{ $t("common.rateSettingByGame") }}({{ $t("table.head.mini") }})</li>
            <li :class="{ active: setRate === 'sport' }" @click="changeTabRate('sport')">{{ $t("common.rateSettingByGame") }}({{ $t("table.head.sport") }})</li>
          </ul>
          <button class="btn-layout user-btn-bg btn-rate" @click="userRateUpdate">{{ $t("button.save") }}</button>
          <div class="notflex content_wrap w100w">
            <table>
              <colgroup>
                <col width="20%" />
              </colgroup>
              <thead>
                <tr>
                  <th>{{ $t("common.allApply") }}</th>
                  <th>{{ $t("common.name") }}</th>
                  <th>{{ $t("common.rolling") }}</th>
                  <th>{{ $t("common.losing") }}</th>
                  <th>{{ $t("common.name") }}</th>
                  <th>{{ $t("common.rolling") }}</th>
                  <th>{{ $t("common.losing") }}</th>
                </tr>
              </thead>
            </table>
            <div v-if="setRate === 'casino'" class="rateSetWrap">
              <div class="rateL w20w">
                <div>
                  <span>{{ $t("common.rolling") }}</span>
                  <div>
                    <button type="button" class="btn-layout btn-range btn-min" @click="rateAllMin(rateList, rateGroup.etc1)">{{ $t("table.head.min") }}</button>
                    <input type="number" class="w50" @change="totalRateLimit('point')" v-model="batchRate_point" />
                    <button type="button" class="btn-layout btn-range btn-max" @click="rateAllMax(rateList, rateGroup.etc1)">{{ $t("table.head.max") }}</button>
                  </div>
                  <button type="button" class="btn-layout btn-apply" @click="rateAllChange('point', 'casino')">{{ $t("table.head.applied") }}</button>
                </div>
                <div>
                  <span>{{ $t("common.losing") }}</span>
                  <div>
                    <button type="button" class="btn-layout btn-range btn-min" @click="rateLoseAllMin(rateList, rateGroup.etc1)">{{ $t("table.head.min") }}</button>
                    <input type="number" class="w50" @change="totalRateLimit('point')" v-model="batchRate_lose" />
                    <button type="button" class="btn-layout btn-range btn-max" @click="rateLoseAllMax(rateList, rateGroup.etc1, userData.recommenderId)">{{ $t("table.head.max") }}</button>
                  </div>
                  <button type="button" class="btn-layout btn-apply" @click="rateAllChange('lose', 'casino')">{{ $t("table.head.applied") }}</button>
                </div>
              </div>
              <div class="rateR w80w">
                <template v-for="item in rateList" :key="item.code">
                  <div class="rate-content w33w" v-if="item.groupCode === 'casino'">
                    <div class="title" v-bind:class="item.groupCode">
                      <span class="mr-5">{{ item.gameName }}</span>
                    </div>
                    <div>
                      <div class="rollcount">
                        <input type="number" @change="rateLimit(index, item.maxRate)" v-model="item.pointRate" />
                      </div>
                    </div>
                    <div>
                      <div class="rollcount">
                        <input type="number" @change="rateLimit(index, item.maxRate)" v-model="item.loseRate" />
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div v-if="setRate === 'slot'" class="rateSetWrap">
              <div class="rateL w20w">
                <div>
                  <span>{{ $t("common.rolling") }}</span>
                  <div>
                    <button type="button" class="btn-layout btn-range btn-min" @click="rateAllMin(rateList, rateGroup.etc1)">{{ $t("table.head.min") }}</button>
                    <input type="number" class="w50" @change="totalRateLimit('point')" v-model="batchRate_point" />
                    <button type="button" class="btn-layout btn-range btn-max" @click="rateAllMax(rateList, rateGroup.etc1)">{{ $t("table.head.max") }}</button>
                  </div>
                  <button type="button" class="btn-layout btn-apply" @click="rateAllChange('point', 'slot')">{{ $t("table.head.applied") }}</button>
                </div>
                <div>
                  <span>{{ $t("common.losing") }}</span>
                  <div>
                    <button type="button" class="btn-layout btn-range btn-min" @click="rateLoseAllMin(rateList, rateGroup.etc1)">{{ $t("table.head.min") }}</button>
                    <input type="number" class="w50" @change="totalRateLimit('point')" v-model="batchRate_lose" />
                    <button type="button" class="btn-layout btn-range btn-max" @click="rateLoseAllMax(rateList, rateGroup.etc1, userData.recommenderId)">{{ $t("table.head.max") }}</button>
                  </div>
                  <button type="button" class="btn-layout btn-apply" @click="rateAllChange('lose', 'slot')">{{ $t("table.head.applied") }}</button>
                </div>
              </div>
              <div class="rateR w80w">
                <template v-for="(item, index) in rateList" :key="item.gameType">
                  <div class="rate-content w33w" v-if="item.groupCode === 'slot'">
                    <div class="title" v-bind:class="item.groupCode">
                      <span class="mr-5">{{ item.gameName }}</span>
                    </div>
                    <div>
                      <div class="rollcount">
                        <input type="number" @change="rateLimit(index, item.maxRate)" v-model="item.pointRate" />
                      </div>
                    </div>
                    <div>
                      <div class="rollcount">
                        <input type="number" @change="rateLimit(index, item.maxRate)" v-model="item.loseRate" />
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div v-if="setRate === 'minigame'" class="rateSetWrap">
              <div class="rateL w20w">
                <div>
                  <span>{{ $t("common.rolling") }}</span>
                  <div>
                    <button type="button" class="btn-layout btn-range btn-min" @click="rateAllMin(rateList, rateGroup.etc1)">{{ $t("table.head.min") }}</button>
                    <input type="number" class="w50" @change="totalRateLimit('point')" v-model="batchRate_point" />
                    <button type="button" class="btn-layout btn-range btn-max" @click="rateAllMax(rateList, rateGroup.etc1)">{{ $t("table.head.max") }}</button>
                  </div>
                  <button type="button" class="btn-layout btn-apply" @click="rateAllChange('point', 'minigame')">{{ $t("table.head.applied") }}</button>
                </div>
                <div>
                  <span>{{ $t("common.losing") }}</span>
                  <div>
                    <button type="button" class="btn-layout btn-range btn-min" @click="rateLoseAllMin(rateList, rateGroup.etc1)">{{ $t("table.head.min") }}</button>
                    <input type="number" class="w50" @change="totalRateLimit('point')" v-model="batchRate_lose" />
                    <button type="button" class="btn-layout btn-range btn-max" @click="rateLoseAllMax(rateList, rateGroup.etc1, userData.recommenderId)">{{ $t("table.head.max") }}</button>
                  </div>
                  <button type="button" class="btn-layout btn-apply" @click="rateAllChange('lose', 'minigame')">{{ $t("table.head.applied") }}</button>
                </div>
              </div>
              <div class="rateR w80w">
                <template v-for="(item, index) in rateList" :key="item.gameType">
                  <div class="rate-content" v-bind:class="item.groupCode" v-if="item.groupCode === 'minigame'">
                    <div class="title">
                      <span class="mr-5">{{ item.gameName }}</span>
                    </div>
                    <template v-if="item.gameType === '33'">
                      <div class="minibtn">
                        <a class="btn-layout btn-apply" @click="minibtn = !minibtn">{{ $t("common.rateDetail") }}</a>
                      </div>
                      <div v-if="minibtn" class="minibox">
                        <a @click="minibtn = !minibtn" class="close"><i class="fa fa-times" aria-hidden="true"></i></a>
                        <table>
                          <template v-for="(mini, miniIndex) in miniGameRateList" :key="mini.rateType">
                            <tr>
                              <td rowspan="2" class="bg">
                                {{ mini.rateType === "SINGLE" ? "일반" : "조합" }}
                              </td>
                              <td>{{ $t("common.rolling") }}</td>
                              <td>
                                <button type="button" class="btn-layout btn-range btn-min" @click="onMiniChangeByLimit(mini.minPointRate, 'point', miniIndex)">{{ $t("table.head.min") }}</button>
                                <input type="number" :class="{ error: mini.errorP }" @change="miniRateLimit(mini.maxPointRate, mini.minPointRate, mini.pointRate, miniIndex, 'P')" class="w80" v-model="mini.pointRate" />
                                <button type="button" class="btn-layout btn-range btn-max" @click="onMiniChangeByLimit(mini.maxPointRate, 'point', miniIndex)">{{ $t("table.head.max") }}</button>
                              </td>
                            </tr>
                            <tr>
                              <td>{{ $t("common.losing") }}</td>
                              <td>
                                <button type="button" class="btn-layout btn-range btn-min" @click="onMiniChangeByLimit(mini.minLoseRate, 'lose', miniIndex)">{{ $t("table.head.min") }}</button>
                                <input type="number" :class="{ error: mini.errorL }" class="w80" @change="miniRateLimit(mini.maxLoseRate, mini.minLoseRate, mini.loseRate, miniIndex, 'L')" v-model="mini.loseRate" />
                                <button type="button" class="btn-layout btn-range btn-max" @click="onMiniChangeByLimit(mini.maxLoseRate, 'lose', miniIndex)">{{ $t("table.head.max") }}</button>
                              </td>
                            </tr>
                          </template>
                        </table>
                        <button type="button" class="btn-layout btn-range btn-max save" @click="onSaveMiniRate">{{ $t("button.save") }}</button>
                      </div>
                    </template>
                    <template v-else>
                      <div>
                        <div class="rollcount">
                          <input type="number" @change="rateLimit(index, item.maxRate)" v-model="item.pointRate" />
                        </div>
                      </div>
                      <div>
                        <div class="rollcount">
                          <input type="number" @change="rateLimit(index, item.maxRate)" v-model="item.loseRate" />
                        </div>
                      </div>
                    </template>
                  </div>
                </template>
              </div>
            </div>
            <div v-if="setRate === 'sport'" class="rateSetWrap">
              <div class="rateL w20w">
                <div>
                  <span>{{ $t("common.rolling") }}</span>
                  <div>
                    <button type="button" class="btn-layout btn-range btn-min" @click="rateAllMin(rateList, rateGroup.etc1)">{{ $t("table.head.min") }}</button>
                    <input type="number" class="w50" @change="totalRateLimit('point')" v-model="batchRate_point" />
                    <button type="button" class="btn-layout btn-range btn-max" @click="rateAllMax(rateList, rateGroup.etc1)">{{ $t("table.head.max") }}</button>
                  </div>
                  <button type="button" class="btn-layout btn-apply" @click="rateAllChange('point', 'sport')">{{ $t("table.head.applied") }}</button>
                </div>
                <div>
                  <span>{{ $t("common.losing") }}</span>
                  <div>
                    <button type="button" class="btn-layout btn-range btn-min" @click="rateLoseAllMin(rateList, rateGroup.etc1)">{{ $t("table.head.min") }}</button>
                    <input type="number" class="w50" @change="totalRateLimit('point')" v-model="batchRate_lose" />
                    <button type="button" class="btn-layout btn-range btn-max" @click="rateLoseAllMax(rateList, rateGroup.etc1, userData.recommenderId)">{{ $t("table.head.max") }}</button>
                  </div>
                  <button type="button" class="btn-layout btn-apply" @click="rateAllChange('lose', 'slot')">{{ $t("table.head.applied") }}</button>
                </div>
              </div>
              <div class="rateR w80w">
                <template v-for="(item, index) in rateList" :key="item.gameType">
                  <div class="rate-content w33w" v-if="item.groupCode === 'sport'">
                    <div class="title" v-bind:class="item.groupCode">
                      <span class="mr-5">{{ item.gameName }}</span>
                    </div>
                    <div>
                      <div class="rollcount">
                        <input type="number" @change="rateLimit(index, item.maxRate)" v-model="item.pointRate" />
                      </div>
                    </div>
                    <div>
                      <div class="rollcount">
                        <input type="number" @change="rateLimit(index, item.maxRate)" v-model="item.loseRate" />
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>

        <div class="allwrap ratewrap" v-if="type == 'rateSet'">
          <div class="notflex content_wrap w50w">
            <button class="btn-layout user-btn-bg btn-rate" @click="onRateNewSave">{{ $t("button.save") }}</button>
            <table>
              <thead>
                <tr>
                  <th></th>
                  <th>{{ $t("common.rolling") }}</th>
                  <th>{{ $t("common.losing") }}</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="memRollingInfo">
                  <template v-for="item in memRollingInfo" :key="item.cateCode">
                    <tr>
                      <td v-if="item.category !== 'minigame'">
                        {{ $t(`table.head.${item.category}`) }}
                      </td>
                      <td v-if="item.category !== 'minigame'">
                        <div class="btnwrap">
                          <button type="button" class="btn-layout btn-range btn-min" @click="onNewChangeByLimit(item.minPointRate, 'point', item)">
                            {{ $t("table.head.min") }}<i>({{ item.minPointRate }})</i>
                          </button>
                          <input type="number" class="w50" :class="{ error: item.errorP }" v-model="item.pointRate" @change="newRateLimit(item.maxPointRate, item.minPointRate, item.pointRate, 'P', item)" />
                          <button type="button" class="btn-layout btn-range btn-max" @click="onNewChangeByLimit(item.maxPointRate, 'point', item)">
                            {{ $t("table.head.max") }}<i>({{ item.maxPointRate }})</i>
                          </button>
                        </div>
                      </td>
                      <td v-if="item.category !== 'minigame'">
                        <div class="btnwrap">
                          <button type="button" class="btn-layout btn-range btn-min" @click="onNewChangeByLimit(item.minLoseRate, 'lose', item)">
                            {{ $t("table.head.min") }}<i>({{ item.minLoseRate }})</i>
                          </button>
                          <input type="number" class="w50" :class="{ error: item.errorR }" v-model="item.loseRate" @change="newRateLimit(item.maxLoseRate, item.minLoseRate, item.loseRate, 'R', item)" />
                          <button type="button" class="btn-layout btn-range btn-max" @click="onNewChangeByLimit(item.maxLoseRate, 'lose', item)">
                            {{ $t("table.head.max") }}<i>({{ item.maxLoseRate }})</i>
                          </button>
                        </div>
                      </td>
                    </tr>
                    <!-- <tr v-else>
                     <td>{{ item.cateCodeName }}</td>
                     <td colspan="2">
                       <div class="minibtn">
                         <a class="btn-layout btn-apply" @click="onRateDetailOpen(item)">{{ $t('common.rateDetail') }}</a>
                       </div>
                       <div v-if="item.isOpenDetail" class="minibox">
                         <a @click="onRateDetailOpen(item)" class="close"><i class="fa fa-times" aria-hidden="true"></i></a>
                         <table>
                           <template v-for="(mini, miniIndex) in item.miniGameRateList" :key="mini.rateType">
                             <tr>
                               <td rowspan="2" class="bg">
                                 {{mini.rateType === 'SINGLE' ? '일반': '조합'}}
                               </td>
                               <td>{{ $t('common.rolling') }}</td>
                               <td>
                                 <button type="button" class="btn-layout btn-range btn-min" @click="onMiniNewChangeByLimit(mini.minPointRate, 'point', miniIndex, item)">{{ $t('table.head.min') }}<i>({{ mini.minPointRate }})</i></button>
                                 <input type="number" :class="{'error' : mini.errorP}" @change="miniNewRateLimit(mini.maxPointRate, mini.minPointRate, mini.pointRate, miniIndex, 'P', item)" class="w80" v-model="mini.pointRate" />
                                 <button type="button" class="btn-layout btn-range btn-max" @click="onMiniNewChangeByLimit(mini.maxPointRate, 'point', miniIndex, item)">{{ $t('table.head.max') }}<i>( {{ mini.maxPointRate }} )</i></button>
                               </td>
                             </tr>
                             <tr>
                               <td>{{ $t('common.losing') }}</td>
                               <td>
                                 <button type="button" class="btn-layout btn-range btn-min" @click="onMiniNewChangeByLimit(mini.minLoseRate, 'lose', miniIndex, item)">{{ $t('table.head.min') }}<i>( {{ mini.minLoseRate }} )</i></button>
                                 <input type="number" :class="{'error' : mini.errorL}" class="w80" @change="miniNewRateLimit(mini.maxLoseRate, mini.minLoseRate, mini.loseRate, miniIndex, 'L', item)" v-model="mini.loseRate" />
                                 <button type="button" class="btn-layout btn-range btn-max" @click="onMiniNewChangeByLimit(mini.maxLoseRate, 'lose', miniIndex, item)">{{ $t('table.head.max') }}<i>( {{ mini.maxLoseRate }} )</i></button>
                               </td>
                             </tr>
                           </template>
                         </table>
                         <button type="button" class="btn-layout btn-range btn-max save" @click="onSaveNewMiniRate(item)">{{ $t('button.save') }}</button>
                       </div>
                     </td>
                   </tr> -->
                  </template>
                </template>
              </tbody>
            </table>
          </div>
        </div>

        <!--div class="modalWrap" v-if="cashModal.active">
           <div class="modal-item">
             <article class="modal-title">
               <sub-title :text="cashModal.type + $t(cashModal.action)" />
               <button class="btn-link modal-close" type="button" @click="cashModalClose">
                 <i class="fas fa-times"></i>
               </button>
             </article>
             <article class="fx-item-auto">
               <input type="number" v-model="cashModal.model.amt" />
             </article>
             <div class="btn-wrap">
               <button v-if="cashModal.type === '보유금'" class="btn-layout btn-red" type="button" @click="cashApply(cashModal.action, userData.memId)">{{ $t(cashModal.action) }}</button>
               <button v-if="cashModal.type === '포인트'" class="btn-layout btn-red" type="button" @click="pointApply(cashModal.action, userData.memId)">{{ $t(cashModal.action) }}</button>
             </div>
           </div>
         </div-->

        <div class="modal-wrapper" v-if="cashModal.active">
          <div class="modal-wrap2">
            <div class="sub-title2">
              <h2>{{ cashModal.type }}</h2>
              <h4>{{ getDomain() }}</h4>
              <a class="btn" @click="cashModalClose"><i class="fa fa-times"></i></a>
            </div>
            <div class="modal-content2">
              <ul class="modal-info">
                <li class="ip-txt">
                  <span class="onlyNum">
                    <input type="number" v-model="cashModal.model.amt" />
                  </span>
                </li>
              </ul>
              <div class="modal-btns" v-if="cashModal.type === '보유금'">
                <a @click="cashApply('in', userData.memId)">{{ $t("button.payment") }}</a>
                <a @click="cashApply('out', userData.memId)">{{ $t("common.coll") }}</a>
              </div>
              <div class="modal-btns" v-if="cashModal.type === '포인트'">
                <a @click="pointApply('in', userData.memId)">{{ $t("button.payment") }}</a>
                <a @click="pointApply('out', userData.memId)">{{ $t("common.coll") }}</a>
              </div>
            </div>
          </div>
        </div>
        <msg-modal v-if="msgOpen" :boardType="'msgList'" :recieveId="userData.memId" :targetType="'member'" :useSendScope="true" @modalClose="modalClose"></msg-modal>
      </template>
    </div>
  </section>
</template>

<script>
import lodash from 'lodash'
import { memberDetail, memberRate, getCode, comBank, memberRateUpdate, memLogout, memStatusChange, memberModify, cashIn, cashOut, memberPointInOut, getGameCodes, resetPassword, partnerBotMemberRateUpdate, setUserBonusSetting, getMultipleRateInfo, setMultipleRateInfo, memberNewRateUpdate, setMoneyMerge } from '@/api/member.js'
import {
  partnerBlankSpinModify, partnerDetail, partnerList, partnerModify,
  partnerSubPwdChg, setBottomMemberLock, setBottomMemberBan, updateAllBlankSpinRate
} from '@/api/partner.js'
import { replaceDateT, numberWithCommas, thousandCount } from '@/libs/utils.js'
import { GAME_INFO_LIST } from '@/libs/constants.js'
import subTitle from '@/components/main/PageSubTitle'
import Pagination from '@/components/common/Pagination'
import msgModal from '@/components/common/msgModal'
import { mapState } from 'vuex'

export default {
  name: 'partnerDetail',
  components: {
    subTitle,
    Pagination,
    msgModal
  },
  computed: {
    ...mapState(['siteOption'])
  },
  data () {
    return {
      newUserPass: '',
      newSubUserPass: '',
      qhover: false,
      setRate: 'casino',
      setBet: 'casino',
      type: 'partdetail',
      currentPassword: '',
      currentMenu: 'tab1',
      userData: null,
      userBonus: null,
      scontentHeight: '0',
      batchRate_insured: '0.00',
      batchRate_point: '0.00',
      batchRate_lose: '0.00',
      bankList: [],
      levels: '',
      cashModal: {
        active: false,
        type: '',
        action: '',
        model: {
          memId: '',
          amt: '',
          memo: ''
        }
      },
      subUserList: [],
      reqData: {
        memId: this.$route.query.id
      },
      insuredLimit: '',
      userRate: [],
      gameList: [],
      rateUpdate: {
        siteId: '',
        memId: '',
        rateList: []
      },

      originRate: [],
      rateList: [],
      insuredRateList: [],
      modifyData: {
        siteId: '',
        memId: '',
        memNick: '',
        memName: '',
        memStatus: '',
        recommenderId: '',
        loginYn: '',
        betYn: '',
        recommendYn: '',
        cashSendYn: '',
        memBlackYn: '',
        memLockYn: '',
        accInfoRequestYn: '',
        memLevel: '',
        sportsLevel: '',
        casinoLevel: '',
        slotLevel: '',
        mgLevel: '',
        pointExchangeYn: '',
        memo: '',
        insuredUpRate: '',
        insuredYn: '',
        subMemRateModifyYn: '',
        // memberCommissionRate: [
        //   {
        //     gameType: '',
        //     pointRate: '',
        //     useYn: '',
        //     betYn: ''
        //   }
        // ],
        memberGameBetYn: [
          {
            gameType: '',
            pointRate: '',
            useYn: '',
            betYn: ''
          }
        ],
        memberFlow: []
      },
      rateGroup: {
        etc1: '',
        etc2: '',
        etc3: ''
      },
      msgOpen: false,
      isBlankSpinCasinoRate: false,
      isBlankSpinSlotRate: false,
      minibtn: false,
      miniGameRateList: [],
      memRollingInfo: []
    }
  },
  methods: {
    getDomain () {
      return location.host
    },
    onRateDetailOpen (item) {
      if (!item.isOpenDetail) {
        const params = {
          siteId: this.siteOption.siteId,
          memId: this.userData.memId,
          vendorCode: item.cateCode
        }

        getMultipleRateInfo(params).then(res => {
          console.log(res)
          if (res.resultCode === '0') {
            console.log(res.data.multipleRateInfo.rateList)
            item.miniGameRateList = res.data.multipleRateInfo.rateList

            item.miniGameRateList.forEach(rate => {
              rate.errorP = false
              rate.errorL = false
            })
          }
        })
      } else {
        item.miniGameRateList = []
      }
      item.isOpenDetail = !item.isOpenDetail
    },
    onMiniNewChangeByLimit (newValue, type, index, item) {
      console.log(newValue, type, index)
      if (type === 'point') {
        item.miniGameRateList[index].pointRate = newValue
      } else {
        item.miniGameRateList[index].loseRate = newValue
      }
    },
    onNewChangeByLimit (newValue, type, item) {
      console.log(newValue, type)
      if (type === 'point') {
        item.pointRate = newValue
      } else {
        item.loseRate = newValue
      }
    },
    onRateNewSave () {
      this.emitter.emit('Loading', true)

      const rateList = []

      this.memRollingInfo.forEach(item => {
        rateList.push({
          category: item.category,
          cateCode: item.cateCode,
          pointRate: item.pointRate,
          loseRate: item.loseRate
        })
      })

      const params = {
        siteId: this.siteOption.siteId,
        memId: this.userData.memId,
        rateList
      }

      memberNewRateUpdate(params).then(res => {
        if (res.resultCode === '0') {
          alert('저장 완료되었습니다.')
        } else {
          alert(res.resultMessage)
        }
        this.emitter.emit('Loading', false)
      })
    },
    newRateLimit (max, min, value, type, item) {
      item.errorP = false
      item.errorR = false
      if (value > max) {
        item['error' + type] = true
      } else if (min > value) {
        item['error' + type] = true
      }
    },
    miniNewRateLimit (max, min, value, index, type, item) {
      item.miniGameRateList[index].errorP = false
      item.miniGameRateList[index].errorR = false
      if (value > max) {
        item.miniGameRateList[index]['error' + type] = true
      } else if (min > value) {
        item.miniGameRateList[index]['error' + type] = true
      }
    },
    onSaveNewMiniRate (item) {
      let isError = false

      item.miniGameRateList.forEach(rate => {
        if (rate.errorP || rate.errorL) {
          isError = true
        }
      })

      if (!isError) {
        const data = {
          siteId: this.siteOption.siteId,
          memId: this.userData.memId,
          vendorCode: '33',
          rateList: item.miniGameRateList
        }
        setMultipleRateInfo(data).then(res => {
          if (res.resultCode === '0') {
            alert('저장 완료되었습니다.')
            this.onRateDetailOpen(item)
          } else {
            alert(res.resultMessage)
          }
        })
      }
    },
    onMiniChangeByLimit (newValue, type, index) {
      console.log(newValue, type, index)
      if (type === 'point') {
        this.miniGameRateList[index].pointRate = newValue
      } else {
        this.miniGameRateList[index].loseRate = newValue
      }
    },
    onSaveMiniRate () {
      let isError = false

      this.miniGameRateList.forEach(item => {
        if (item.errorP || item.errorL) {
          isError = true
        }
      })

      if (!isError) {
        const data = {
          siteId: this.siteOption.siteId,
          memId: this.userData.memId,
          vendorCode: '33',
          rateList: this.miniGameRateList
        }
        setMultipleRateInfo(data).then(res => {
          if (res.resultCode === '0') {
            alert('저장 완료되었습니다.')
            this.minibtn = false
          } else {
            alert(res.resultMessage)
          }
        })
      }
    },
    miniRateLimit (max, min, value, index, type) {
      this.miniGameRateList[index].errorP = false
      this.miniGameRateList[index].errorR = false
      if (value > max) {
        this.miniGameRateList[index]['error' + type] = true
      } else if (min > value) {
        this.miniGameRateList[index]['error' + type] = true
      }
    },
    thousandCount,
    onChangeType (type) {
      this.type = type
    },
    changeTabRate (setRate) {
      if (setRate === 'minigame') {
        const params = {
          siteId: this.siteOption.siteId,
          memId: this.userData.memId,
          vendorCode: '33'
        }

        getMultipleRateInfo(params).then(res => {
          console.log(res)
          if (res.resultCode === '0') {
            this.miniGameRateList = res.data.multipleRateInfo.rateList

            this.miniGameRateList.forEach(item => {
              item.errorP = false
              item.errorL = false
            })
          }
        })
      }
      this.setRate = setRate
    },
    changeTabBet (setBet) {
      this.setBet = setBet
    },
    formatValueWithCommas (value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    async setUserBonus (field) {
      const confirmMessage = '보너스 설정을 저장하시겠습니까?'
      if (confirm(confirmMessage)) {
        const param = {
          memId: this.userData.memId,
          fstChrgByJoinRate: null,
          fstChrgByDailyRate: null,
          fstChrgByEveryTimeRate: null,
          bonusLimit: null
        }

        param[field] = this.userBonus[field]

        await setUserBonusSetting(param).then(async res => {
          console.log(res)
          if (res.resultCode === '0') {
            alert('정상적으로 보너스 설정이 저장되었습니다.')
            await this.getUserDetail()
          } else {
            alert('오류가 발생하였습니다. 다시 시도해주세요.')
          }
        })
      }
    },
    async lockBotMemberSetting () {
      if (confirm('설정된 값으로 하부전체회원(파트너포함)에게 설정됩니다. 동의하시면 진행해주세요.\n')) {
        const params = {
          memId: this.userData.memId,
          memLockYn: this.userData.memLockYn ? 'Y' : 'N'
        }
        // console.log('params', params)

        setBottomMemberLock(params).then(res => {
          if (res.resultCode === '0') {
            alert('정상적으로 하부전체회원(파트너포함)에게 설정되었습니다.')
          } else {
            alert('오류가 발생하였습니다. 다시 시도해주세요.')
          }
        })
      }
    },
    async blackBotMemberSetting () {
      if (confirm('설정된 값으로 현재 파트너와 하부전체계정에게 설정됩니다. 동의하시면 진행해주세요.\n')) {
        const params = {
          memId: this.userData.memId,
          memBlackYn: this.userData.memBlackYn ? 'Y' : 'N'
        }

        setBottomMemberBan(params).then(res => {
          if (res.resultCode === '0') {
            alert('정상적으로 현재 파트너와 하부전체계정에게 설정되었습니다.')
          } else {
            alert('오류가 발생하였습니다. 다시 시도해주세요.')
          }
        })
      }
    },
    async blankBotMemberSetting () {
      const confirmationMessage = `설정된 값으로 하부전체회원(파트너포함)에게 설정됩니다. 동의하시면 진행해주세요.\n
"카지노" 공베팅은 다음과 같은 공식이 적용됩니다.
당첨금이 베팅금 보다 큰 경우는 확률계산에서 제외되어 공베팅이 적용되지 않습니다.
이점 숙지하시고 이용해 주시기 바랍니다.
      `
      if (confirm(confirmationMessage)) {
        const params = {
          memId: this.userData.memId,
          blankSpinCasinoRate: this.userData.blankSpinCasinoRate,
          blankSpinSlotRate: this.userData.blankSpinSlotRate
        }

        await updateAllBlankSpinRate(params).then(res => {
          if (res.resultCode === '0') {
            alert('하부 전체 저장 완료')
          } else {
            alert('하부 전체 저장 실패. 다시 시도해주세요')
          }
        })
      }
    },
    async allBotMemberRateSetting () {
      if (confirm('모든 직 하부 회원(파트너제외)들의 롤링/루징 요율이 지금 설정해 놓은 요율로 설정됩니다. 동의하십니까?')) {
        this.emitter.emit('Loading', true)
        const reqData = {
          memId: this.userData.memId,
          rateList: []
        }
        const rateList = lodash.cloneDeep(this.rateList)
        for (const item of rateList) {
          if (item.pointRate) {
            if (Number(item.pointRate) > Number(item.originPointRate)) {
              alert('롤링 포인트가 최대값보다 큽니다.')
              this.emitter.emit('Loading', false)
              return false
            }
            if (Number(item.pointRate) < Number(0)) {
              alert('롤링 포인트가 최소값보다 큽니다.')
              this.emitter.emit('Loading', false)
              return false
            }
          }
          if (item.loseRate) {
            if (Number(item.loseRate) > Number(item.originLoseRate)) {
              alert('루징 포인트가 최대값보다 큽니다.')
              this.emitter.emit('Loading', false)
              return false
            }
            if (Number(item.loseRate) < Number(0)) {
              alert('루징 포인트가 최소값보다 큽니다.')
              this.emitter.emit('Loading', false)
              return false
            }
          }
          const model = {
            gameType: item.gameType,
            pointRate: item.pointRate,
            loseRate: item.loseRate
          }
          reqData.rateList.push(model)
        }
        console.log('req : ', reqData)
        const res = await partnerBotMemberRateUpdate(reqData)
        console.log('res', res)
        this.emitter.emit('Loading', false)
        if (res.resultCode === '0') {
          const upResult = res.data.updResult
          if (upResult.resultCode === '0') {
            alert('요율설정 완료')
          } else {
            alert(upResult.resultMsg)
          }
        } else {
          alert('요율설정 실패, 다시 시도해주세요.')
        }
      }
    },
    async resetPassword () {
      if (confirm('비밀번호를 초기화하시겠습니까?')) {
        const params = {
          memId: this.userData.memId
        }
        const res = await resetPassword(params)
        if (res.resultCode === '0') {
          alert('비밀번호가 초기화되었습니다.')
        } else {
          alert('비밀번호 초기화에 실패하였습니다. 조금 후 다시 시도해주세요.')
        }
      }
    },
    setCurrentTab (type) {
      this.currentMenu = type
      document.querySelector('#' + type).scrollIntoView({ behavior: 'smooth' })
    },
    openRateSetting () {
      const name = 'rateSettings'
      const targetId = this.memberDetail.siteId

      const size = {
        width: 585,
        height: 840
      }
      const position = {
        top: 0,
        left: 150
      }
      const routeData = this.$router.resolve({ name, params: { id: targetId } })
      window.open(routeData.href, 'rateSetting', `top=${position.top},left=${position.left},scrollbars=no,resizable=no,width=${size.width},height=${size.height},status=no`)
    },
    // rateAllChange() {
    //   console.log('click')
    //   const target = this.$refs.ptRateControl;
    //   let value = target.value;
    //   console.log(value);
    //   if (value > 100) {
    //     // console.log("value=1000");
    //     value = 100;
    //   } else if (value < 0) {
    //     // console.log("value=0");
    //     value = 0;
    //   }
    //   const ptRates = this.memberDetail.memberCommissionRate;
    //   for (const item of ptRates) {
    //     const itemMaxRate = item.maxRate;
    //     console.log(item.maxRate);
    //     console.log(value);
    //     console.log(itemMaxRate < value);
    //     // const itemRate = item.pointRate;
    //     if (Number(itemMaxRate) < Number(value)) {
    //       item.pointRate = itemMaxRate;
    //     } else {
    //       item.pointRate = value;
    //     }
    //   }
    // },
    totalRateLimit (type) {
      let controlRate = 0
      if (type === 'point') {
        controlRate = this.batchRate_point
      } else if (type === 'insured') {
        controlRate = this.batchRate_insured
      }
      const n = Number(controlRate).toFixed(2)
      if (n >= 100) {
        controlRate = (100).toFixed(2)
      } else if (n < 0) {
        controlRate = (0).toFixed(2)
      } else {
        controlRate = Number(controlRate).toFixed(2)
      }
    },
    rateAllChange (type, groupCode) {
      let controlRate = '0.00'
      let rateList = []
      if (type === 'point') {
        controlRate = this.batchRate_point
        rateList = this.rateList
      } else if (type === 'insured') {
        controlRate = this.batchRate_insured
        rateList = this.insuredRateList
      } else if (type === 'lose') {
        controlRate = this.batchRate_lose
        rateList = this.rateList
      }

      for (const item of rateList) {
        let limit
        if (type === 'point') {
          limit = Number(item.maxPointRate)
        } else if (type === 'insured') {
          limit = Number(item.maxRate)
        } else if (type === 'lose') {
          limit = Number(item.maxLoseRate)
        }
        const controlRateNumber = Number(controlRate)
        if (controlRateNumber > limit) {
          if (!groupCode || item.groupCode === groupCode) {
            if (type === 'lose') {
              item.loseRate = limit.toFixed(2)
            } else {
              item.pointRate = limit.toFixed(2)
            }
          }
        } else {
          if (!groupCode || item.groupCode === groupCode) {
            if (type === 'lose') {
              item.loseRate = controlRateNumber.toFixed(2)
            } else {
              item.pointRate = controlRateNumber.toFixed(2)
            }
          }
        }
      }
    },
    async getLevels () {
      const data = await getCode('memLevel')
      this.levels = data
    },
    async _memLogout (memId) {
      const reqData = {
        memId
      }
      const res = await memLogout(reqData)
      if (res.resultCode === '0') {
        alert('로그아웃 처리 완료')
      } else {
        alert('로그아웃 처리 실패')
      }
    },

    async pointApply (type, memId) {
      let res = ''
      if (type === 'in') {
        const model = lodash.cloneDeep(this.cashModal.model)
        const req = {
          memId,
          pointType: 2,
          pointDesc: '관리자 포인트 지급',
          pointAmt: model.amt / Number(this.siteOption.cashDecimal),
          memo: ''
        }
        res = await memberPointInOut(req)
        if (res.resultCode === '0') {
          alert('지급완료')
          await this.getUserDetail()
          this.cashModalClose()
          this.cashModal.reqData.inAmt = ''
        } else if (res.resultCode === 'P006') {
          alert('포인트지급,회수 처리는 1분에 1건씩 처리됩니다. 잠시후 다시 시도해주세요')
        } else {
          alert('지급실패, 다시 시도해주세요.')
        }
      } else if (type === 'out') {
        const model = lodash.cloneDeep(this.cashModal.model)
        if (this.userData.pointAmt < model.amt) {
          model.amt = 0
          alert('회수포인트는 보유포인트보다 적어야 합니다.')
          return
        }
        const req = {
          memId,
          pointType: -2,
          pointDesc: '관리자 포인트 회수',
          pointAmt: (model.amt / Number(this.siteOption.cashDecimal)) * -1,
          memo: ''
        }
        res = await memberPointInOut(req)
        if (res.resultCode === '0') {
          alert('회수 완료')
          await this.getUserDetail()
          this.cashModalClose()
          this.cashModal.model.amt = ''
        } else {
          alert('회수실패, 다시 시도해주세요.')
        }
      }
    },
    async cashApply (type, memId) {
      let res = ''
      if (type === 'in') {
        const model = lodash.cloneDeep(this.cashModal.model)
        const req = {
          memId,
          inAmt: model.amt / Number(this.siteOption.cashDecimal),
          memo: model.memo,
          type: '관리자 보유금 지급',
          inBonusYn: 'N'
        }
        res = await cashIn(req)
        if (res.resultCode === '0') {
          alert('지급완료')
          await this.getUserDetail()
          this.cashModalClose()
          this.cashModal.model.amt = ''
        } else {
          alert('지급실패, 다시 시도해주세요.')
        }
      } else if (type === 'out') {
        if (this.userData.cashAmt < this.cashModal.model.amt) {
          this.cashModal.model.amt = 0
          alert('회수금액은 보유금액보다 적어야 합니다.')
          return
        }
        const model = lodash.cloneDeep(this.cashModal.model)
        const req = {
          memId,
          outAmt: model.amt / Number(this.siteOption.cashDecimal),
          memo: model.memo,
          type: '관리자 보유금 회수',
          bonusRollingYn: 'N'
        }
        res = await cashOut(req)
        if (res.resultCode === '0') {
          alert('회수 완료')
          await this.getUserDetail()
          this.cashModalClose()
          this.cashModal.model.amt = ''
        } else {
          if (res.resultCode === 'C702') {
            alert('회수할 금액이 유저 보유금보다 많을 수 없습니다.')
          } else if (res.resultCode === 'C099') {
            alert(res.resultMessage)
          } else {
            alert('회수실패, 다시 시도해주세요.')
          }
        }
      }
    },
    async userPassUpdate () {
      if (!this.newUserPass) {
        alert('변경할 비밀번호를 입력해주세요.')
      } else {
        const reqData = {
          memId: this.userData.memId,
          memPass: this.newUserPass
        }
        // console.log(reqData)
        const res = await partnerModify(reqData)
        if (res.resultCode === '0') {
          alert('비밀번호 변경 완료')
        } else {
          alert('비밀번호 변경실패, 다시 시도해주세요.')
        }
      }
    },
    async subUserPassUpdate () {
      if (!this.newSubUserPass) {
        alert('변경할 직하부 회원 비밀번호를 입력해주세요.')
      } else {
        if (confirm('모든 직하부 회원 비밀번호가 입력하신 문자로 변경됩니다. 진행하시겠습니까?')) {
          const reqData = {
            memId: this.userData.memId,
            memPass: this.newSubUserPass
          }
          // console.log(reqData)
          const res = await partnerSubPwdChg(reqData)
          if (res.resultCode === '0') {
            alert('직하부 회원 비밀번호 변경 완료')
          } else {
            alert('직하부 회원 비밀번호 변경실패, 다시 시도해주세요.')
          }
        }
        // const reqData = {
        //   memId: this.userData.memId,
        //   memPass: this.newUserPass
        // };
        // // console.log(reqData)
        // const res = await partnerModify(reqData);
        // if (res.resultCode === "0") {
        //   alert("비밀번호 변경 완료");
        // } else {
        //   alert("비밀번호 변경실패, 다시 시도해주세요.");
        // }
      }
    },
    async userInfoUpdate () {
      const reqData = {
        memId: this.userData.memId,
        memNick: this.userData.memNick,
        memName: this.userData.memName,
        memLevel: this.userData.memLevel,
        cashOutPass: this.userData.cashOutPass,
        bank: this.userData.bank,
        bankacc: this.userData.bankacc,
        memPhone: this.userData.memPhone,
        insuredYn: lodash.cloneDeep(this.userData.insuredYn)
      }

      if (this.userData.memPass !== this.currentPassword) {
        reqData.memPass = this.currentPassword
      }

      if (reqData.insuredYn) {
        reqData.insuredYn = 'Y'
      } else {
        reqData.insuredYn = 'N'
      }
      for (const key in reqData) {
        if (reqData.bank && !reqData.bankacc) {
          alert(this.$t('table.head.bankacc') + '를 입력해주세요.')
          return
        }
        if (!reqData.bank && reqData.bankacc) {
          alert(this.$t('table.head.bank') + '를 입력해주세요.')
          return
        }
        if (!reqData[key]) {
          if (key === 'bank' && key === 'bankacc') {
            alert(this.$t(`table.head.${key}`) + '를 입력해주세요.')
            return
          }
        }
      }
      const res = await partnerModify(reqData)
      if (res.resultCode === '0') {
        alert('회원정보수정 완료')
      } else {
        alert('회원정보 변경실패, 다시 시도해주세요.')
      }
    },
    async userMemoUpdate () {
      const reqData = {
        memId: this.userData.memId,
        memo: this.userData.memo
      }
      const res = await partnerModify(reqData)
      if (res.resultCode === '0') {
        alert('상담메모수정 완료')
      } else {
        alert('상담메모수정실패, 다시 시도해주세요.')
      }
    },
    async userGLevelUpdate () {
      const reqData = {
        memId: this.userData.memId,
        sportsLevel: this.userData.sportsLevel,
        casinoLevel: this.userData.casinoLevel,
        slotLevel: this.userData.slotLevel,
        mgLevel: this.userData.mgLevel
      }
      const res = await partnerModify(reqData)
      if (res.resultCode === '0') {
        alert('게임레벨 수정 완료')
      } else {
        alert('게임레벨 수정 실패, 다시 시도해주세요.')
      }
    },
    async userRateUpdate () {
      this.emitter.emit('Loading', true)
      const reqData = {
        siteId: this.userData.siteId,
        memId: this.userData.memId,
        rateList: []
      }
      const rateList = lodash.cloneDeep(this.rateList)
      for (const item of rateList) {
        if (item.pointRate) {
          if (Number(item.pointRate) > Number(item.maxPointRate)) {
            alert('롤링 포인트가 최대값보다 큽니다.')
            return false
          }
          if (Number(item.pointRate) < Number(item.minPointRate)) {
            alert('롤링 포인트가 최소값보다 큽니다.')
            return false
          }
        }
        if (item.loseRate) {
          if (Number(item.loseRate) > Number(item.maxLoseRate)) {
            alert('루징 포인트가 최대값보다 큽니다.')
            return false
          }
          if (Number(item.loseRate) < Number(item.minLoseRate)) {
            alert('루징 포인트가 최소값보다 큽니다.')
            return false
          }
        }
        const model = {
          useYn: 'Y',
          gameType: item.gameType,
          pointRate: item.pointRate,
          loseRate: item.loseRate,
          betYn: 'N'
        }
        reqData.rateList.push(model)
      }
      console.log('req : ', reqData)
      const res = await memberRateUpdate(reqData)
      console.log('res', res)
      location.reload()
      this.emitter.emit('Loading', false)
      if (res.resultCode === '0') {
        alert('요율설정 완료')
      } else if (res.resultCode === 'U031') {
        alert(res.resultMessage)
      } else {
        alert('요율설정 실패, 다시 시도해주세요.')
      }
      // location.reload();
    },
    async userSettingUpdate () {
      const reqData = {
        memId: this.userData.memId,
        memName: this.userData.memName,
        accInfoRequestYn: this.userData.accInfoRequestYn,
        loginYn: this.userData.loginYn,
        memLockYn: this.userData.memLockYn,
        memBlackYn: this.userData.memBlackYn,
        pointExchangeYn: this.userData.pointExchangeYn,
        cashSendYn: this.userData.cashSendYn,
        cashReceiveYn: this.userData.cashReceiveYn,
        recommendYn: this.userData.recommendYn,
        subMemRateModifyYn: this.userData.subMemRateModifyYn
      }
      const req = lodash.cloneDeep(reqData)
      for (const key in req) {
        // console.log(typeof req[key] === "boolean");
        if (typeof req[key] === 'boolean') {
          if (req[key]) {
            req[key] = 'Y'
          } else {
            req[key] = 'N'
          }
        }
      }
      // console.log(req)
      // return;
      const res = await partnerModify(req)
      if (res.resultCode === '0') {
        alert('기능설정 완료')
      } else {
        alert('기능설정 실패, 다시 시도해주세요.')
      }
    },
    async userSettingUpdateBlank () {
      const confirmationMessage = `설정된 값으로 직하부회원(파트너제외)에게 설정됩니다. 동의하시면 진행해주세요.\n
"카지노" 공베팅은 다음과 같은 공식이 적용됩니다.
당첨금이 베팅금 보다 큰 경우는 확률계산에서 제외되어 공베팅이 적용되지 않습니다.
이점 숙지하시고 이용해 주시기 바랍니다.
      `
      if (confirm(confirmationMessage)) {
        const reqData = {
          memId: this.userData.memId,
          blankSpinCasinoRate: Number(this.userData.blankSpinCasinoRate),
          blankSpinSlotRate: Number(this.userData.blankSpinSlotRate)
        }

        const res = await partnerBlankSpinModify(reqData)
        if (res.resultCode === '0') {
          alert('기능설정 완료')
        } else {
          alert('기능설정 실패, 다시 시도해주세요.')
        }
      }
    },
    parentLinkMove (linkTarget, memId) {
      // console.log("move");
      window.open(`${linkTarget}?id=${memId}`, '_blank')
      // window.opener.location.href = `${linkTarget}?id=${memId}`;
    },
    parentLinkMovePopup (linkTarget, memId) {
      // console.log("move");
      // window.opener.location.href = `${linkTarget}?id=${memId}`;

      const name = 'CashMoveHistory'
      const size = {
        width: 1920,
        height: 1000
      }
      const position = {
        top: 100,
        left: Math.ceil((window.screen.width - size.width) / 2)
      }

      window.open(`${linkTarget}?id=${memId}`, `${name}`, `top=${position.top},left=${position.left},scrollbars=no,resizable=no,width=${size.width},height=${size.height},status=no`)
      /* `Detail_${type}`, `top=${position.top},left=${position.left},scrollbars=no,resizable=no,width=${size.width},height=${size.height},status=no` */
    },
    async getSubMemberInfo () {
      const reqData = {
        memId: this.userData.memId,
        searchType: 'tree'
      }
      const res = await partnerList(reqData)
      // console.log(res);
      const list = res.data.list
      if (list) {
        this.userData.subMemCnt = list.length
      } else {
        this.userData.subMemCnt = 0
      }
      this.subUserList = list
      // console.log(this.subUserList);
    },
    switchToggle (event) {
      const toggle = event.target
      const text = toggle.previousElementSibling
      // console.log(toggle.checked)
      if (text) {
        if (toggle.checked) {
          text.classList.remove('off')
          text.classList.add('on')
        } else {
          text.classList.remove('on')
          text.classList.add('off')
        }
      }
    },
    async getBank () {
      // console.log(this.siteInfo);
      const req = {
        siteId: this.siteInfo.siteId
      }
      const res = await comBank(req)
      this.bankList = res.data.list
    },
    cashModalOpen (type) {
      const _type = type.split('_')
      if (_type[0] === 'cash') {
        this.cashModal.type = '보유금'
      } else if (_type[0] === 'point') {
        this.cashModal.type = '포인트'
      }

      /* if (_type[1] === 'in') {
        this.cashModal.action = 'in'
      } else if (_type[1] === 'out') {
        this.cashModal.action = 'out'
     } */

      this.cashModal.active = true
    },
    modalClose (value) {
      this.msgOpen = value
    },
    cashModalClose () {
      this.cashModal.model.amt = 0
      this.cashModal.active = false
    },
    modalControl (memId) {
      this.getUserDetail(memId)
      this.modal.target = memId
      this.modal.active = !this.modal.active
    },
    writeOpen () {
      msgOpen = true
    },
    historyOpen () {
      // window.open("/cms/cash/history", "cashHistory", "top=100,left=150,scrollbars=no,resizable=no,width=565,height=701,status=no");
    },
    async getPartnerDetail () {
      const res = await partnerDetail(this.reqData)
      if (res.resultCode !== '0') {
        this.emitter.emit('Loading', false)
        return false
      }
      console.log('partner detail : ', res)
      this.userData = res.data.member
      this.userBonus = { ...res.data.bonusSettingInfo }
      this.currentPassword = JSON.parse(JSON.stringify(this.userData.memPass))

      if (this.userData.lastLoginDt) {
        this.userData.lastLoginDt = replaceDateT(this.userData.lastLoginDt)
      }
      this.userData.regDt = replaceDateT(this.userData.regDt)
      this.userData.totalWlAmt = numberWithCommas(this.userData.totalWlAmt)
      this.userData.totalLoginCount = numberWithCommas(this.userData.totalLoginCount)
      this.userData.totalCashOutAmt = numberWithCommas(this.userData.totalCashOutAmt)
      this.userData.totalCashInAmt = numberWithCommas(this.userData.totalCashInAmt)
      this.userData.totalBonusAmt = numberWithCommas(this.userData.totalBonusAmt)

      this.isBlankSpinCasinoRate = !!this.userData.blankSpinCasinoRate
      this.isBlankSpinSlotRate = !!this.userData.blankSpinSlotRate

      for (const item in this.userData) {
        if (item.indexOf('Yn') !== -1 && item !== 'memberCommissionRate') {
          if (this.userData[item] === 'Y') {
            this.userData[item] = true
          } else {
            this.userData[item] = false
          }
        }
      }
      this.subUserList = res.data.userList
      const memberFlow = res.data.memberFlow.filter(item => {
        return item.recommenderId && item.recommenderId !== item.siteId ? item : null
      })

      this.memberFlow = this.jsonSort(memberFlow, 'order', 'desc')
      this.memberFlow = this.memberFlow.splice(1, this.memberFlow.length - 2)
      console.log('memberFlow : ', this.memberFlow)

      this.rateUpdate.siteId = res.data.member.siteId
      this.rateUpdate.memId = res.data.member.memId

      this.memRollingInfo = res.data.memRollingInfo
      this.memRollingInfo.forEach(item => {
        // if (item.detailSetYn === 'Y') {
        //   item.isOpenDetail = false
        // } else {
        item.errorP = false
        item.errorR = false
        // }
      })
    },
    getUserRate () {
      return memberRate(this.reqData)
    },
    getGameCode () {
      return getGameCodes('kplay', '', '', this.siteInfo.siteId)
    },
    setRateLoop (maxRate) {
      return maxRate / 0.05
    },
    getMemLevel () {
      this.userData.memLevel
    },
    async pageSeach () {
      this.siteInfo = this.getSiteInfo()
      this.emitter.emit('Loading', true)
      if (this.reqData.memId) {
        await this.setGameList()
        await this.getBank()
        await this.getLevels()
        await this.getPartnerDetail()

        this.gameList = this.$store.getters.gameList

        this.scontentSetting()
      } else {
        this.userData = null
      }
      this.emitter.emit('Loading', false)
    },
    async setMemStatus () {
      const reqData = {
        memId: this.userData.memId,
        memStatus: this.userData.memStatus
      }
      try {
        const res = await memStatusChange(reqData)
        if (res.resultCode !== '0') {
          alert('회원상태 변경에 실패했습니다. 다시 시도해주세요.')
        } else {
          alert('회원상태 변경완료')
        }
      } catch (e) {
        alert('회원상태 변경에 실패했습니다. 다시 시도해주세요.')
      }
    },
    setRateListDefault () {
      for (const loop of this.gameListDefault) {
        for (const item of loop.child) {
          const model = lodash.cloneDeep(this.rateModel)
          model.gameType = item.code
          model.gameName = item.codeName
          model.groupCode = item.groupCode
          model.loop = Number(model.maxPointRate) / this.rateIncrease
          this.rateList.push(model)
        }
      }
      this.combineUserRate()
    },
    setInsuredListDefault () {
      // console.log(this.gameListDefault);
      for (const loop of this.gameListDefault) {
        for (const item of loop.child) {
          const model = lodash.cloneDeep(this.rateModel)
          model.gameType = item.code
          model.gameName = item.codeName
          model.groupCode = item.groupCode
          model.loop = 100 / this.rateIncrease
          model.maxRate = 100
          this.insuredRateList.push(model)
        }
      }
      // this.combineUserRate();
    },
    combineUserRate () {
      const rateList = lodash.cloneDeep(this.rateList)
      const newArray = []
      // for (const loop of this.userData.memberCommissionRate) {
      //   rateList.forEach((target, index, arr) => {
      //     if (target.gameType === loop.gameType) {
      //       target.originPointRate = loop.pointRate
      //       target.originLoseRate = loop.loseRate
      //       target.pointRate = loop.pointRate
      //       target.loseRate = loop.loseRate
      //       target.maxLoseRate = loop.maxLoseRate
      //       target.minLoseRate = loop.minLoseRate
      //       target.maxRate = loop.maxRate
      //       target.maxPointRate = loop.maxPointRate
      //       target.minPointRate = loop.minPointRate
      //       target.loop = Math.round(Number(target.maxRate) / this.rateIncrease)
      //       if (loop.betYn === 'Y') {
      //         target.betYn = true
      //       } else {
      //         target.betYn = false
      //       }
      //       if (loop.useYn === 'Y') {
      //         target.useYn = true
      //       } else {
      //         target.useYn = false
      //       }
      //       return false
      //     }
      //   })
      // }
      this.originRate = rateList
      this.rateList = rateList
    },
    scontentSetting () {
      const scontent = document.querySelectorAll('.s-content-wrap')

      if (scontent.length > 0) {
        const parent = scontent[0].parentElement
        const title = scontent[0].previousElementSibling
        const pHeight = parent.clientHeight
        const tHeight = title.offsetHeight
        const targetHeight = pHeight - (tHeight + 5)
        this.scontentHeight = targetHeight
      }

      // console.log(scontent)
    },
    async moneyMerge () {
      const confirmMessage = '통합머니 전환을 진행하시겠습니까?'
      if (confirm(confirmMessage)) {
        const param = {
          memId: this.userData.memId
        }

        await setMoneyMerge(param).then(async res => {
          console.log(res)
          if (res.resultCode === '0') {
            alert('정상적으로 통합머니 전환이 완료되었습니다.')
            await this.getPartnerDetail()
          } else {
            alert('오류가 발생하였습니다. 다시 시도해주세요.')
          }
        })
      }
    }
  },
  watch: {
    isBlankSpinCasinoRate () {
      if (this.isBlankSpinCasinoRate && !this.userData.blankSpinCasinoRate) {
        this.userData.blankSpinCasinoRate = 1
      } else if (!this.isBlankSpinCasinoRate) {
        this.userData.blankSpinCasinoRate = 0
      }
    },
    isBlankSpinSlotRate () {
      if (this.isBlankSpinSlotRate && !this.userData.blankSpinSlotRate) {
        this.userData.blankSpinSlotRate = 1
      } else if (!this.isBlankSpinSlotRate) {
        this.userData.blankSpinSlotRate = 0
      }
    },
    'userData.blankSpinCasinoRate' () {
      this.userData.blankSpinCasinoRate = Math.round(this.userData.blankSpinCasinoRate)
      if (this.userData.blankSpinCasinoRate > 100) {
        this.userData.blankSpinCasinoRate = 100
      }
      if (this.userData.blankSpinCasinoRate) {
        this.isBlankSpinCasinoRate = true
      } else {
        this.isBlankSpinCasinoRate = false
      }
    },
    'userData.blankSpinSlotRate' () {
      this.userData.blankSpinSlotRate = Math.round(this.userData.blankSpinSlotRate)
      if (this.userData.blankSpinSlotRate > 100) {
        this.userData.blankSpinSlotRate = 100
      }
      if (this.userData.blankSpinSlotRate) {
        this.isBlankSpinSlotRate = true
      } else {
        this.isBlankSpinSlotRate = false
      }
    },
    gameList: {
      handler (value) {
        this.setRateListDefault(value)
        this.setInsuredListDefault()
      }
    }
  },
  async created () {
    this.siteInfo = this.getSiteInfo()

    this.emitter.emit('Loading', true)
    await this.getBank()
    await this.getLevels()
    if (this.$route.query.id) {
      await this.getPartnerDetail()
      // await this.getSubMemberInfo()
      await this.setGameList()

      this.gameList = this.$store.getters.gameList
      this.scontentSetting()
    }
    this.emitter.emit('Loading', false)
  }
}
</script>

<style scoped>
.partnerName {
  color: #876a97;
  font-size: 12px;
}
.partnerName em {
  color: #ff7e00;
}
.bg {
  background: #f9f9f9 !important;
  width: 25%;
}
.allwrap > .wrapper.fx-col {
  width: 100%;
}
.allwrap .user-wrapper-outer > .middle-wrap > table {
  width: auto;
}
.fx {
  display: flex !important;
}
.mr10 {
  margin-right: 10px;
}
.ml20 {
  margin-left: 20px;
  border-left: 1px solid #b7b7b7;
  padding-left: 10px;
}
.btn-grey {
  width: 70px;
  height: 22px;
  padding: 0 12px;
  color: #fff;
  cursor: pointer;
}
.mb50 {
  margin-bottom: 50px;
}
.mb20 {
  margin-bottom: 20px;
}
.scrolltTop {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  color: #fff;
  width: 80px;
  height: 45px;
  float: right;
}
.active .btn-t-inner {
  display: none;
}
.fstColumn.userList .levelColor {
  display: block;
}
.btnwrap {
  display: flex;
  align-items: center;
  gap: 15px;
}

.box-hideOpen .levelColor {
  background: rgb(255, 218, 38);
  width: 8px;
}
.seletAndDelete {
  display: flex;
  align-items: center;
}
.msg-all-sel {
  margin-right: 4px !important;
  height: 30px;
  box-sizing: border-box;
}
#siteId {
  margin-right: 4px;
}
.btn-state-change.cancle {
  margin-right: 4px;
}
.user-detail-popup {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  gap: 20px;
  width: fit-content;
  margin: 0;
  box-sizing: border-box;
  background: #353535;
}
.user-detail-popup select {
  border: 1px solid #313a49;
  height: 30px;
}
.main-contents-wrapper > div {
  margin: 0;
}
.wrapper-title > .subWrap > span {
  font-size: initial;
}
.user-memo-wrap textarea {
  border: 1px solid #313a49;
  height: 234px;
}
.user-memo-wrap .content {
  margin: 20px 22px;
}
.user-wrapper-outer > .middle-wrap {
  display: block;
}
.user-wrapper-outer > .middle-wrap .content > .title {
  width: 250px;
  color: #353535;
}
.allwrap .user-wrapper-outer#tab11 > .middle-wrap > table {
  width: 100%;
}
#tab11 th {
  font-size: 14px;
}
#tab11 td {
  text-align: center;
}
#tab11 td input {
  border: 1px solid #000;
  width: 110px;
  padding: 5px;
  box-sizing: border-box;
}
#tab11 .content .btn-save {
  padding: 4px 7px;
  margin-left: 5px;
}
.wrapper-title {
  width: auto;
  height: 45px;
  border-bottom: 1px solid #313a49;
  padding: 0 22px;
}
.wrapper-title > span {
  font-size: 14px;
}
.wrapper-title .btn-save {
  padding: 0 12px;
}
.wrapper-title .btn-save-ver2 {
  padding: 0 12px;
}
.button-wrap {
  display: flex;
  gap: 6px;
}
.button-wrap > button {
  flex: 1;
  height: 28px;
  box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  border: solid 1px #0cae61;
  background-color: #0cae61;
  color: #fff;
}
.button-wrap > button:last-child {
  margin-right: 0;
}
.s-content > .content {
  display: flex;
  height: 36px;
  margin-left: auto;
}
.s-content > .content > input {
  width: 50px;
}
.modal-item {
  width: 500px;
  margin: 0 auto;
  position: relative;
  top: 20%;
  background: #353535;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  overflow: hidden;
}
.modal-close {
  top: -5px;
  color: #e1534e;
}
.sub-title {
  border-bottom: 2px solid #e1534e;
  color: #fff;
}
.modal-item .fx-item-auto {
  text-align: center;
  margin: 20px 0;
}
.modal-item .fx-item-auto input {
  color: #000;
  font-size: 14px;

  width: 100%;
  max-width: 190px;
  height: 26px;
  border: 1px solid #353535;
  border-radius: 3px;
  background-color: #fff;
  position: relative;
}
.btn-wrap {
  margin-bottom: 25px;
  justify-content: center;
  gap: 10px;
}
.btn-wrap button {
  width: 200px;
  height: 35px;
  font-size: 18px;
}
.table-wrap {
  overflow-y: scroll;
  max-height: 120px;
  margin: 15px 22px;
}

.supComp-list-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  font-size: 14px;
}
[class*="compColor"] {
  /* font-weight: bold; */
}
button[class*="compColor"]:after {
  content: "▶";
  display: inline;
  margin-left: 5px;
}
[class*="compColor"]:last-child:after {
  content: "";
}
.compColor-target {
  color: #d93832;
}
.s-content-wrap {
  max-height: initial;
}
.s-content:nth-child(4n + 1) {
  padding: 0;
  border: 0;
}
.s-content {
  /*flex-basis: 74px;
  max-width: 74px;
  min-height: 30px;
  font-size: 14px;
  border: 0;*/
  flex-basis: calc(25% - 18px);
  font-size: 14px;
  border: 0;
  display: flex;
  border-left: 1px solid #313a49;
  padding-left: 10px;
  margin: 0;
}
.s-content > .title {
  overflow: hidden;
  text-overflow: ellipsis;
  background: none;
  /*color: #353535;*/
}

/* .casino{
  color: #af0000;
}

.slot{
  color: #008d59;
} */

.user-wrapper-outer {
  display: flex;
  flex-direction: column;
  background: #fff;
  width: 100%;
  border: 0;
  border: 3px solid #353535;
  padding: 0;
}
.user-wrapper-outer .wrapper-contents {
  flex: 0 1 calc(100% - 42px);
  gap: 5px 10px;
  margin: 15px 22px;
}
.rate-item-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 8px;
  flex-wrap: wrap;
}

.rate-item-wrap {
  width: fit-content;
  display: flex;
  flex-wrap: nowrap;
  flex: 0 1 23.1%;
}
.rate-item-wrap .item-title {
  margin-right: 4px;
  display: inline-flex;
  align-items: center;
  font-weight: 700;
  width: 78px;
  flex: 1 0 auto;
  word-break: keep-all;
  /* white-space: nowrap; */
}
.rate-item-container .item-title > span {
  /* overflow: hidden;
  text-overflow: ellipsis; */
}
.rate-item-container .item-line {
  width: 1px;
  background: #c5c5c5;
  height: 25px;
}
.rate-item-container .info-box {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: fit-content;
  padding: 5px 8px;
  font-weight: 700;
  border-radius: 3px;
  width: 46px;
  font-size: 1em;
  margin-right: 0;
  border: 1px solid #c5c5c5;
  user-select: none;
}

.rate-item-container .item-line:last-child {
  display: none;
}
.batchRate {
  width: 70px;
  text-align: center;
}
.rollLoss {
  align-items: center;
}
.rollLoss > span {
  margin: 0 10px 0 15px;
}
.toggle-wrap input[type="text"] {
  width: 62px;
  margin-left: 10px;
}
/*리뉴얼*/
.allwrap {
  margin: 0 35px;
  position: relative;
}
.mt-20 {
  margin-top: -20px;
}
.w50 {
  width: 50px;
}
.w80 {
  width: 80px !important;
}
.tab-item:hover {
  background: #2f78ee;
  color: #fff;
}
.tab-item.active {
  background: #2f78ee;
}
.w284 {
  width: 284px;
}
.allwrap {
  max-width: 1600px;
}
.allwrap > div {
  display: flex;
  gap: 20px;
}
.allwrap > div.notflex {
  display: block;
}
.allwrap > div.center {
  justify-content: center;
}
.content_wrap.all {
  width: 100%;
  flex-direction: row;
}
.content_wrap.all > div:first-child {
  width: 65%;
}
.content_wrap.all > div {
  width: 35%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.part-wrap {
  display: flex;
  gap: 20px;
}
.part-box {
  width: 100%;
}
.part-box:last-child {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 23px;
}
.part-in {
}
.content_wrap.w100w {
  width: 100%;
}
.content_wrap.w50w {
  width: 50%;
}
.content_wrap table th {
  padding: 7px 14px;
  text-align: left;
}
.content_wrap table thead th.flexEnd {
  display: flex;
  justify-content: flex-end;
}
.content_wrap table thead th:nth-child(2) .saveBtnWrap {
  display: flex;
  gap: 10px;
}
.saveBtnWrap .user-btn-bg {
  padding: 3px 10px;
  white-space: nowrap;
}
.user-btn-bg.chasnge-partner {
  color: #fff;
  background: #82a6a4;
  border: 1px solid #82a6a4;
}
.user-btn-bg.chasnge-partner:hover {
  color: #fff;
  background: #82a6a4;
}
.content_wrap table td {
  height: 30px;
  padding: 1px 14px;
  /* border: 1px solid #b1b1b1; */
  /* background-color: #fff; */
}
input[type="text"],
input[type="password"],
input[type="number"] {
  width: 120px;
}
select.w_half {
  width: 90px !important;
}
select.w_full {
  width: 186px !important;
}
.w_half:nth-child(1),
.w_full:nth-child(1) {
  margin-right: 5px;
}
.setTab {
  display: flex;
}
.setTab li {
  cursor: pointer;
  width: 224px;
  height: 40px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  color: #bebebe;
  border-radius: 3px 3px 0 0;
  border: solid 1px #d5d5d5;
  background-color: #fff;
  box-sizing: border-box;
}
.setTab li.active {
  color: #000;
  background-color: #f9f9f9;
  border-top: 3px solid #eb7a3f;
  box-shadow: 1px 0 2px 0 rgba(0, 0, 0, 0.16);
}
.gameSetWrap {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  background: #fff;
}
.gameSet {
  width: 20%;
  display: flex;
}
.gameSet > * {
  font-size: 12px;
  color: #585963;
  white-space: nowrap;
  padding: 10px 13px;
  box-sizing: border-box;
  border: 1px solid #b1b1b1;
  background: #fff;
}
.gameSet > *:nth-child(1) {
  width: 70%;
  display: flex;
  align-items: center;
}
.gameSet > *:nth-child(2) {
  width: 30%;
  border-left: 0;
  border-right: 0;
}
.gameSet:nth-child(5n) > *:nth-child(2) {
  border-right: 1px solid #d5d5d5;
}
.gameSet:last-child > *:nth-child(2) {
  position: relative;
}
.gameSet:last-child > *:nth-child(2)::after {
  content: "";
  position: absolute;
  top: 0;
  right: -1px;
  height: 45px;
  width: 1px;
  display: inline-block;
  background: #d5d5d5;
}
.rateSetWrap {
  display: flex;
  width: 100%;
  background: #fff;
}
.rateSetWrap .rateL {
  width: 33%;
}
.rateSetWrap .rateR {
  width: 67%;
}
.rateL.w20w {
  width: 20%;
}
.rateR.w80w {
  width: 80%;
  display: flex;
  flex-wrap: wrap;
}
.rateL > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 13px;
  font-size: 14px;
  box-sizing: border-box;
  border: 1px solid #d5d5d5;
}
.rateL > .btn-layout {
  padding: 3px 7px;
  color: #fff;
}
.btn-range {
  background: #6f7172;
}
.btn-min {
  border-radius: 3px 0 0 3px;
  margin-right: 5px;
}
.btn-max {
  border-radius: 0 3px 3px 0;
  margin-left: 5px;
}
.btn-min i {
  margin-left: 5px;
  color: #a4bbfd;
}
.btn-max i {
  margin-left: 5px;
  color: #ffa06e;
}
.btn-apply {
  background: #eb7a3f;
  border-radius: 3px;
}
.rate-content {
  border: 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
}
.rateR.w80w .rate-content {
  width: 50%;
}
.rate-content > .content {
  display: flex;
  font-size: 14px;
  height: 36px;
}
.rate-content > div {
  box-sizing: border-box;
  border: 1px solid #d5d5d5;
  width: 33.33%;
  padding: 5px 12px;
  font-size: 14px;
  height: 52px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
}
.minibtn {
  width: 66.66% !important;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.minibox {
  z-index: 100;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: auto !important;
  height: auto !important;
  padding: 40px 40px 30px !important;
  background: #fff;
  flex-direction: column;
  gap: 15px;
  box-sizing: border-box;
  border: 1px solid #d5d5d5;
  white-space: nowrap;
  display: flex;
  align-items: center;
}
.minibox table {
  height: 100%;
}
.minibox td > div {
  display: flex;
  align-items: center;
  gap: 10px;
}
.minibox .close {
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 20px;
  cursor: pointer;
}
.minibox button.save {
  padding: 10px 40px;
  font-size: 16px;
}
.minibox .error {
  border: 1px #944747 solid;
}

.rate-content .rollcount {
  display: flex;
  align-items: center;
  border: 1px solid #d5d5d5;
  border-radius: 3px;
}
.rate-content > div:nth-child(2) {
  border-left: 0;
  border-right: 0;
}
.rollcount > input[type="number"] {
  width: 85px;
  text-align: center;
  border-top: 0;
  border-bottom: 0;
  border-right: 1px solid #d5d5d5;
  border-left: 1px solid #d5d5d5;
}
.center button {
  margin: 50px 0 70px;
  font-size: 18px;
  width: 160px;
  height: 40px;
  background: #eb7a3f;
  border-radius: 3px;
  color: #fff;
  border: 0;
  font-weight: 600;
}
textarea {
  width: 100%;
  min-height: 155px;
  padding: 5px 0;
  height: 100%;
  resize: none;
  box-sizing: border-box;
  font-size: 15px;
}
.user-btn-bg {
  background: #252930;
  border-radius: 4px;
  font-size: 12px;
  transition: 0.3s;
}
.user-btn-bg:hover {
  background: #fff;
  color: #000;
}
.inputBtnWrap {
  display: flex;
  gap: 5px;
  align-items: center;
}
.inputBtnWrap span {
  /*display: inline-block;*/
}
.btn-layout {
  border-radius: 3px;
  padding: 3px 11px;
}
.btn-point {
  background: #eb7a3f;
}
.widthSet {
  display: flex;
  justify-content: space-between;
}
.rollcount button {
  color: #676767;
  font-weight: bold;
  font-size: 1.2em;
  background: #fff;
  padding: 0 5px;
}
input[type="number"].w50 {
  width: 50px;
}
.btn-rate {
  position: absolute;
  top: 0;
  right: 0;
}
.memTable tr:nth-child(1) td {
  /* background: #f7f7f7; */
}
.mamListTable tbody {
  max-height: 250px;
  overflow: auto;
}
.hoverWrap {
  position: relative;
}
.icon_q {
  width: 18px;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #db7b7b;
  color: #db7b7b;
  font-weight: bold;
  border-radius: 100%;
  cursor: pointer;
}
.hoverWrap p {
  position: absolute;
  border: 2px solid #db7b7b;
  padding: 8px;
  background: #fff;
  border-radius: 5px;
  top: -98px;
  left: -315px;
  width: 340px;
  font-size: 14px;
  box-sizing: border-box;
  transition: 0.3s;
}
.ratewrap .content_wrap {
  position: relative;
  padding-top: 50px;
}
.ratewrap .btn-rate {
  top: 10px;
  right: 12px;
}
.btnwrap {
  display: flex;
  justify-content: center;
}
.btn-inout {
  width: auto;
  height: auto;
  padding: 3px 6px;
  cursor: pointer;
}
@media (max-width: 1092px) {
  .content_wrap.all {
    flex-direction: column;
  }
  .content_wrap.all > div:nth-child(1) {
    width: 100%;
  }
  .content_wrap.all > div:nth-child(2) {
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .content_wrap.all > div:nth-child(2) > table {
    width: calc(50% - 10px);
  }
  .content_wrap.all > div:nth-child(2) > div {
    width: 100%;
  }
  .content_wrap.w50w {
    width: 100%;
  }
}
</style>
